import { SortByDirection } from '@patternfly/react-table';
import axiosConfig from '../axiosConfig';
import { ActivityLogsResponse, GenericResponse } from '../types';

export type TActivityLog = {
	activityType: string;
	created_at: number;
	entity_id: number | null;
	entity_type: string | null;
	id: number;
	ipAddress: string;
	job_queue_id: number | null;
	message: string;
	target: any;
	user: number;
	context: any;
};

export class ActivityLog implements TActivityLog {
	activityType: string;
	created_at: number;
	entity_id: number | null;
	entity_type: string | null;
	id: number;
	ipAddress: string;
	job_queue_id: number | null;
	message: string;
	target: any;
	user: number;
	context: any;

	constructor(activityLog: TActivityLog) {
		this.activityType = activityLog.activityType;
		this.created_at = activityLog.created_at;
		this.entity_id = activityLog.entity_id;
		this.entity_type = activityLog.entity_type;
		this.id = activityLog.id;
		this.ipAddress = activityLog.ipAddress;
		this.job_queue_id = activityLog.job_queue_id;
		this.message = activityLog.message;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
		this.target = activityLog.target;
		this.user = activityLog.user;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
		this.context = activityLog.context;
	}

	public static GetAll(
		pageNumber: number,
		perPage: number,
		sortDirection: SortByDirection,
		searchTerm: string
	): Promise<GenericResponse<ActivityLogsResponse>> {
		const request = {
			filters: searchTerm,
			sort: sortDirection,
			page: pageNumber,
			items_per_page: perPage,
		};
		return axiosConfig.instance
			.post<GenericResponse<ActivityLogsResponse>>('/app/activity-log', request)
			.then((res) => {
				return res.data;
			});
	}
}
